import TopicModel from './models/TopicModel';
import TopicEditModel from './models/TopicEditModel';

const TopicStore = {
  name: 'TopicStore',
  spec: TopicModel,
  saveLocally: false,
  initialState: {
    id: '',
    isbn: '',
    topicTitle: '',
    genus: [],
    specialty: '',
    isFree: false,
    top3: false,
    genusMaster: [],
    specialityMaster: [],
  }
};
const TopicEditStore = {
  name: 'TopicEditStore',
  spec: TopicEditModel,
  saveLocally: false,
  initialState: {
    res:"Oops...Something went wrong. Please try again."
  },
};

const stores=[TopicStore, TopicEditStore]

export default stores;